module.exports = __webpack_public_path__ + "871cfd2dc0548d101102b574d45e2d65.svg";